import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

import { previewModeOptions } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/constants'

import * as Styles from './styles'

const PreviewModeChip = ({ previewMode }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const previewModeOption = previewModeOptions.find(option => option.id === previewMode)

  return (
    <Tooltip title={t(previewModeOption.description)} arrow position="right">
      <Styles.ChipWrapper>
        <Chip
          label={t(previewModeOption.label)}
          backgroundColor={theme.colors.primary.surface}
          color={theme.colors.primary.onSurface}
        />
      </Styles.ChipWrapper>
    </Tooltip>
  )
}

export default PreviewModeChip
